import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import api from '../../services/api';
import { getMediaUrl } from '../../services/api';
import './SliderSection.css';

const SliderSection = ({ section, layout = 'default' }) => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSlides();
  }, []);

  const loadSlides = async () => {
    try {
      const response = await api.get('/sliders/');
      setSlides(response.data);
    } catch (error) {
      console.error('Error loading slides:', error);
    } finally {
      setLoading(false);
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    pauseOnHover: true,
    arrows: true,
  };

  const renderSlideContent = (slide) => {
    const slideElement = (
      <div className="slide-item">
        <div 
          className="slide-content" 
          style={{ 
            backgroundImage: slide.image 
              ? `url(${getMediaUrl(slide.image)})` 
              : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
          }}
        >
          <div className="slide-overlay">
            <div className="container">
              <div className="slide-text">
                <h2>{slide.title}</h2>
                {slide.subtitle && <p>{slide.subtitle}</p>}
                {slide.link_url && slide.link_text && (
                  <a 
                    href={slide.link_url} 
                    className={`btn btn-light btn-lg slide-button-${slide.button_style || 'primary'}`}
                  >
                    {slide.link_text}
                    <i className="fas fa-arrow-right ms-2"></i>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    // If there's a link_url, wrap the entire slide as a clickable link
    if (slide.link_url && !slide.link_text) {
      return (
        <a 
          key={slide.id} 
          href={slide.link_url} 
          style={{ textDecoration: 'none' }}
        >
          {slideElement}
        </a>
      );
    }

    return <div key={slide.id}>{slideElement}</div>;
  };

  // Show default slide if no slides loaded
  if (loading || slides.length === 0) {
    return (
      <section className="slider-section">
        <div className="slide-item">
          <div 
            className="slide-content" 
            style={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}
          >
            <div className="slide-overlay">
              <div className="container">
                <div className="slide-text">
                  <h2>Welcome to Municipal Corporation</h2>
                  <p>Building a Smart and Sustainable City</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`slider-section slider-layout-${layout}`}>
      <Slider {...settings}>
        {slides.map(slide => renderSlideContent(slide))}
      </Slider>
    </section>
  );
};

export default SliderSection;
